import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Checkbox } from '../ui/checkbox';
import { Skeleton } from '../ui/skeleton';
import { Input } from '../ui/input';

export const NumeracionCard = ({
  numbering,
  numberingLoading,
  manualMode,
  setManualMode,
  numeroManual,
  setNumeroManual,
  manualOcupado,
}) => (
  <Card className="border-2 border-emerald-200 bg-emerald-50/30" data-testid="numeracion-card">
    <CardHeader className="py-4">
      <CardTitle className="font-heading text-lg text-emerald-800">Numeración de la OT</CardTitle>
      <p className="text-sm text-emerald-700">
        El N° se asigna automático dentro del rango del proyecto. Puedes forzar otro N° disponible del rango.
      </p>
    </CardHeader>
    <CardContent className="space-y-4">
      {numberingLoading ? (
        <Skeleton className="h-10 w-full" />
      ) : numbering?.siguiente_propuesto != null ? (
        <>
          <div className="flex flex-wrap items-center gap-4">
            <div className="px-4 py-2 rounded-lg bg-emerald-600 text-white" data-testid="numero-automatico">
              <span className="text-xs block opacity-80">{manualMode && numeroManual ? 'N° forzado' : 'N° automático'}</span>
              <span className="text-2xl font-bold font-mono">OT-{manualMode && numeroManual ? numeroManual : numbering.siguiente_propuesto}</span>
            </div>
            <label className="flex items-center gap-2 text-sm cursor-pointer" data-testid="toggle-manual">
              <Checkbox checked={manualMode} onCheckedChange={(c) => { setManualMode(!!c); if (!c) setNumeroManual(''); }} data-testid="checkbox-manual" />
              Usar un N° disponible específico
            </label>
            {manualMode && (
              <Input
                type="number"
                value={numeroManual}
                onChange={(e) => setNumeroManual(e.target.value)}
                placeholder={`Ej: ${numbering.huecos?.[0] ?? numbering.siguiente_propuesto}`}
                className="w-40 font-mono"
                data-testid="input-numero-manual"
              />
            )}
          </div>

          {manualOcupado && (
            <p className="text-sm text-destructive font-medium" data-testid="manual-ocupado">
              El N° {numeroManual} ya está en uso. Elige uno disponible.
            </p>
          )}

          {numbering.huecos?.length > 0 && (
            <div data-testid="huecos-info">
              <p className="text-xs text-gray-600 mb-1.5">N° disponibles en el rango (clic para usar):</p>
              <div className="flex flex-wrap gap-1.5">
                {numbering.huecos.slice(0, 12).map((n) => (
                  <button
                    key={n}
                    type="button"
                    onClick={() => { setManualMode(true); setNumeroManual(String(n)); }}
                    className={`px-2 py-0.5 text-xs font-mono rounded border transition-colors ${String(numeroManual) === String(n) ? 'bg-emerald-600 text-white border-emerald-600' : 'bg-white text-emerald-700 border-emerald-300 hover:bg-emerald-600 hover:text-white'}`}
                    data-testid={`btn-usar-${n}`}
                  >
                    {n}
                  </button>
                ))}
                {numbering.huecos.length > 12 && (
                  <span className="text-xs text-gray-400 self-center">+{numbering.huecos.length - 12} más</span>
                )}
              </div>
            </div>
          )}

          <div>
            <p className="text-sm font-medium mb-2">OTs existentes de este proyecto ({numbering.usados?.length || 0})</p>
            {numbering.usados?.length > 0 ? (
              <div className="max-h-48 overflow-auto border rounded-md bg-white">
                <table className="w-full text-sm" data-testid="ots-existentes-table">
                  <thead className="bg-muted sticky top-0">
                    <tr>
                      <th className="px-3 py-1.5 text-left">N°</th>
                      <th className="px-3 py-1.5 text-left">Descripción</th>
                      <th className="px-3 py-1.5 text-left">Cliente</th>
                    </tr>
                  </thead>
                  <tbody>
                    {numbering.usados.map((u) => (
                      <tr key={u.numero} className="border-t" data-testid={`ot-existente-${u.numero}`}>
                        <td className="px-3 py-1.5 font-mono font-semibold">{u.numero}</td>
                        <td className="px-3 py-1.5 text-gray-600">{u.descripcion || '—'}</td>
                        <td className="px-3 py-1.5 text-gray-600">{u.cliente_nombre || '—'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p className="text-sm text-gray-500">
                Este proyecto aún no tiene OTs. Esta será la primera (N° {numbering.siguiente_propuesto}).
              </p>
            )}
          </div>
        </>
      ) : (
        <p className="text-sm text-gray-500">Se asignará un N° automático al guardar.</p>
      )}
    </CardContent>
  </Card>
);
